import { localize } from "utils/localizer";

const i18n = {
    activeCheckIn: {
        en: (clubName: string, until: string) => `You are checked-in at ${clubName} until ${until}.`,
        de: (clubName: string, until: string) => `Du bist bei ${clubName} bis ${until} eingecheckt.`,
    },
    addPerson: {
        en: "Another person",
        de: "Weitere Person",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    appDownload: {
        en: "Download app",
        de: "App herunterladen",
    },
    checkIn: {
        en: "Check-in",
        de: "Einchecken",
    },
    checkOut: {
        en: "Check-out",
        de: "Auschecken",
    },
    checkOutSuccessful: {
        en: "Checked-out successfully",
        de: "Erfolgreich ausgecheckt",
    },
    city: {
        en: "City",
        de: "Stadt",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    consent: {
        en: "By clicking \"Check-in\", you agree that your data will be temporarily saved for purposes of contact tracing ",
        de: "Mit einem Klick auf \"Einchecken\" erklärst du dich mit der befristeten Speicherung deiner Daten zu Zwecken der Kontaktnachverfolgung einverstanden ",
    },
    duration: {
        en: "Duration",
        de: "Dauer",
    },
    fullName: {
        en: "Full name",
        de: "Vollständiger Name",
    },
    hours: {
        en: (hours: number) => `${hours} Hour${hours === 1 ? "" : "s"}`,
        de: (hours: number) => `${hours} Stunde${hours === 1 ? "" : "n"}`,
    },
    invalidLink: {
        en: "Invalid QR code or link",
        de: "Ungültiger QR-Code oder Link",
    },
    person: {
        en: "Person",
        de: "Person",
    },
    postalCode: {
        en: "Postal code",
        de: "Postleitzahl",
    },
    privacyPolicy: {
        en: "Privacy Policy",
        de: "Datenschutzerklärung",
    },
    remove: {
        en: "Remove",
        de: "Entfernen",
    },
    sameContactData: {
        en: "Use same contact data",
        de: "Kontaktdaten übernehmen",
    },
    street: {
        en: "Street and house number",
        de: "Straße und Hausnummer",
    },
    telephoneCountryCode: {
        en: "Telephone country code",
        de: "Landesvorwahl",
    },
    telephoneNumber: {
        en: "Telephone number",
        de: "Telefonnummer",
    },
};

export default localize(i18n);
